import { useNavigate } from 'react-router-dom-v5-compat';
import { RouterProvider } from '@nordlayer/rivendell-ui';
import { jsx as _jsx } from "react/jsx-runtime";
export var ReactAriaRouterProvider = function ReactAriaRouterProvider(_ref) {
    var children = _ref.children;
    var navigate = useNavigate();
    return /*#__PURE__*/ _jsx(RouterProvider, {
        navigate: navigate,
        children: children
    });
};
